import ExcelJS from "exceljs";
import XlsxPopulate from 'xlsx-populate/browser/xlsx-populate';
const ExcelExportHelperNotSuccess = (data, date) => {
    const handleExport = () => {
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet("สรุปงานต่อวัน");
        sheet.pageSetup.paperSize = 9;
        sheet.pageSetup.orientation = 'landscape';
        sheet.pageSetup.fitToPage = true;
        sheet.pageSetup.centerVertically = true;
        sheet.pageSetup.centerHorizontally = true;
        sheet.pageSetup.fitToHeight = 0;
        sheet.pageSetup.pa = 0;
        sheet.views = [{ state: 'frozen', showGridLines: false, ySplit: 4 }];
        sheet.pageSetup.printTitlesRows = '4:4';
        sheet.pageSetup.margins = {
            top: 0.5,
            bottom: 0.25,
            left: 0.25,
            right: 0.25,
            header: 0,
            footer: 0
        };

        const columnWidths = [10, 16, 16, 16, 16, 16, 16, 26, 26, 16, 26, 17];
        columnWidths.forEach((width, index) => {
            sheet.getColumn(index + 1).width = width;
        });
        data.forEach((item, index) => {
            sheet.getRow(5 + index).height = 25;
            sheet.alignment = { horizontal: 'center', vertical: 'center' };
        });

        const title = "รายงานการวิ่งงานประจำวันของธนาคาร UOB";
        const title2 = "DGF Express";
        const titledate = "รายงานประจำวันที่";
        const datadate = date;
        const status = `สถานะ : งานไม่สำเร็จ`;
        const numStatus = `จำนวนงานที่ไม่สำเร็จ  ${data.length} งาน`;

        sheet.mergeCells('A1:F1');
        const titleCell = sheet.getCell('A1');
        titleCell.value = title;
        titleCell.font = { size: 16 };
        titleCell.alignment = { horizontal: 'center', vertical: 'middle' };
        sheet.mergeCells('G1:H1');
        const title2Cell = sheet.getCell('G1');
        title2Cell.value = title2;
        title2Cell.font = { size: 16 };
        title2Cell.alignment = { horizontal: 'center', vertical: 'middle' };

        sheet.mergeCells('A2:B2');
        const titleDate = sheet.getCell('A2');
        titleDate.value = titledate
        titleDate.font = { size: 16 };
        titleDate.alignment = { horizontal: 'left', vertical: 'middle' };
        sheet.mergeCells('C2:F2');
        const dataDate = sheet.getCell('C2');
        dataDate.value = datadate
        dataDate.font = { size: 16 };
        dataDate.alignment = { horizontal: 'left', vertical: 'middle' };

        sheet.mergeCells('G2:H2');
        const statuss = sheet.getCell('G2');
        statuss.value = status
        statuss.font = { size: 16 };
        statuss.height = 40;
        statuss.alignment = { horizontal: 'left', vertical: 'top' };
        statuss.style.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
        };
        sheet.mergeCells('B3:F3');
        const numstatuss = sheet.getCell('B3');
        numstatuss.value = numStatus
        numstatuss.font = { size: 16 };
        numstatuss.height = 40;
        numstatuss.alignment = { horizontal: 'left', vertical: 'top' };
        const header = [
            "ลำดับ",
            "นัดลูกค้า",
            "Code Sup",
            "Code Sales",
            "Name Sales",
            "ประเภท",
            "No.ใบสั่ง",
            "ชื่อ-สกุลลูกค้า",
            "พื้นที่ที่สั่งงาน",
            "Zone",
            "หมายเหตุ",
            "ผลการวิ่งงาน",
        ];


        const headerRow = sheet.getRow(4);
        headerRow.height = 30;
        header.forEach((value, index) => {
            const cell = headerRow.getCell(index + 1);
            cell.value = value;
            cell.font = { size: 15, bold: true };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
            cell.style.border = {
                top: { style: 'medium' },
                left: { style: 'medium' },
                bottom: { style: 'medium' },
                right: { style: 'medium' },
            };
        });
        sheet.addRow([]);
        data.forEach((row) => {
            const rowData = [
                parseInt(row.list_no),
                row.docudate.toString(),
                row.sup_code,
                row.emp_code,
                row.sale_name,
                row.job_type_name,
                row.listno_order.toString(),
                row.customer_name,
                row.order_area_name,
                row.zone_master_name,
                row.remark,
                row.status_document_master_name,
            ];

            rowData.forEach((value, index) => {
                const cell = sheet.getCell(data.indexOf(row) + 5, index + 1);
                cell.value = value;
                cell.font = { size: 15 };
                cell.style.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });
        });

        const fileName = `รายงานการวิ่งงานประจำวันที่ ${date} ของธนาคาร UOB สถานะงาน ไม่สำเร็จ`;
        workbook.xlsx.writeBuffer().then((buffer) => {
            XlsxPopulate.fromDataAsync(buffer).then((workbook) => {
                workbook.outputAsync({ password: 'dgf334' }).then((blob) => {
                    const url = URL.createObjectURL(blob);
                    const downloadAnchorNode = document.createElement("a");
                    downloadAnchorNode.setAttribute("href", url);
                    downloadAnchorNode.setAttribute("download", fileName);
                    downloadAnchorNode.click();
                    downloadAnchorNode.remove();
                });
            });
        });
    };

    handleExport();
};

export default ExcelExportHelperNotSuccess;
